import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, Subject, throwError, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { SnackBarService } from '../snackbar-service/snackbar.service';
import { SnackbarType } from 'app/constants/Enums';
import { Profile } from 'app/models';
import { first } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { ApiUrl } from 'app/constants/ApiUrls';

@Injectable()
export class ProfileApiService {
  readonly profileUrl = `${environment.apiUrl}/api/v2/Profiles`;
  private onDestroy$ = new Subject<void>();

  constructor(
    private _http: HttpClient,
    private _translateService: TranslateService,
    public _snackbarService: SnackBarService
  ) {}

  public getProfile(id: string): Observable<Profile> {
    return this._http.get(`${this.profileUrl}/${id}`).pipe(
      map((data) => data as Profile),
      catchError(this.handleError)
    );
  }

  public recoverUser(email: string): Observable<any> {
    return this._http
      .post(`${ApiUrl.profileV2}/Recover`, {email:email}, { observe: 'response', headers: new HttpHeaders({
        'content-Type': 'application/json' // eslint-disable-line
        })})
      .pipe(
        first(),
        map((response) => {
          let successMsg: string;
          let success: string;
          // Check if the user was recovered or not
          if (response.status === 200) {
            this._translateService
              .get('RecoverUser_SuccessMessage')
              .pipe(takeUntil(this.onDestroy$))
              .subscribe((value) => (successMsg = value));
            this._translateService
              .get('SNACKBAR.success')
              .pipe(takeUntil(this.onDestroy$))
              .subscribe((value) => (success = value));
            this._snackbarService.showSnackbar(
              SnackbarType.success,
              success,
              successMsg
            );
          }
          return of(true);
        }),
        catchError(() => {
          this._handleRecoverUserError();
          return of(false);
        })
      );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error(`[identity-api] ERROR: ${error.error.message}`);
    } else {
      console.error(
        `[identity-api] STATUS: ${error.status}, ERROR: ${error.message}`
      );
    }
    return throwError(error);
  }

  private _handleRecoverUserError() {
    let errorTitle ='';
    let genericErrorMsg = "";
    this._translateService
    .get('ERROR_TRY_LATER')
    .pipe(takeUntil(this.onDestroy$))
    .subscribe((value) => (genericErrorMsg = value));
    this._translateService
      .get('SNACKBAR.error')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((value) => (errorTitle = value));
    this._snackbarService.showSnackbar(SnackbarType.error, errorTitle, genericErrorMsg);
  }
}
